import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9edc20c0&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=9edc20c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edc20c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/47.102.216.211-loffice-frontend-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9edc20c0')) {
      api.createRecord('9edc20c0', component.options)
    } else {
      api.reload('9edc20c0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9edc20c0&scoped=true&", function () {
      api.rerender('9edc20c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BaseSelect/index.vue"
export default component.exports